import { SchedulerMachine } from './machine';
import { SchedulerItem } from './item';
import { DragDropItem } from '../../drag-drop/types/item';
import { Batch } from 'src/app/api/elite/types/batch';
import { WorkOrder } from 'src/app/api/elite/types/work-order';
import { SchedulerWorkOrder } from './work-order';

export abstract class SchedulerItemOnMachine extends DragDropItem {
  id: number;
  machineId: number;
  abstract get itemId(): number;
  workOrder?: SchedulerWorkOrder;
  isRunning = false;
  isCurrent = false;
  get rank(): string {
    return this.__rank;
  }
  set rank(value: string) {
    this.__rank = value;
  }
  get rankNumber(): number {
    return this.__rankNumber;
  }
  set rankNumber(value: number) {
    this.__rankNumber = value;
  }
  lastOperationDate: string;

  machine: SchedulerMachine;

  createdAt: string;
  abstract get item(): SchedulerItem;
}
